export default __webpack_public_path__ + "static/media/1-1_bars.96e06b7a.svg";